export default __webpack_public_path__ + "static/media/placeOrder.12962589.jpg";